module.exports = __webpack_public_path__ + "static/media/lakeside.7a4789dc.png";